import attentionSchool from '../../Assets/layout_images/attentionSchool.svg'
import crashSchool from '../../Assets/layout_images/crashSchool.svg'
import winnerSchool from '../../Assets/layout_images/winnerSchool.svg'
import wonSchool from '../../Assets/layout_images/wonSchool.svg'
import notesSchool from '../../Assets/layout_images/notesSchool.svg'
import mediumSchool from '../../Assets/layout_images/mediumSchool.svg'
import examsSchool from '../../Assets/layout_images/examsSchool.svg'
import textbook from '../../Assets/layout_images/textbook.svg'

export const benefits = {
    state: [
        {
            image: attentionSchool,
            title: 'Individual Attention',
            content: 'One Student. One Teacher. One AI'
        },
        {
            image: wonSchool,
            title: 'Conquer every exam',
            content: 'Get support for all your difficult subjects.'
        },
        {
            image: textbook,
            title: 'Become a Textbook Pro',
            content:
                'Grasp STATE textbook concepts and practical uses with your online tutor.'
        },
        {
            image: examsSchool,
            title: 'Grow Plan',
            content: 'Get smarter with regular revisions and personalized ‘Grow Plan’.'
        },
        
    ],
    cbse: {
        class7: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: wonSchool,
                title: 'Conquer every exam',
                content:
                    'Get support for all your difficult subjects.'
            },
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp CBSE textbook concepts and practical uses with your online tutor.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ],
        class8: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: wonSchool,
                title: 'Conquer every exam',
                content:
                    'Get support for all your difficult subjects.'
            },
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp CBSE textbook concepts and practical uses with your online tutor.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ]
    },
    icse: {
        class7: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: crashSchool,
                title: 'Quick Study Option',
                content:
                    'Get instant support through individual online tuition for exams.'
            },
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp ICSE textbook concepts and practical uses with online.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ],
        class8: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: crashSchool,
                title: 'Quick Study Option',
                content:
                    'Get instant support through individual online tuition for exams.'
            },
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp ICSE textbook concepts and practical uses with online.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ]
    },
    igcse: {
        class7: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: wonSchool,
                title: 'Conquer every exam',
                content:
                    'Get support for all your difficult subjects.'
            },
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp IGCSE textbook concepts and practical uses with your online tutor.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ],
        class8: [
            {
                image: attentionSchool,
                title: 'Individual Attention',
                content:
                    'One Student. One Teacher. One AI'
            },
            {
                image: wonSchool,
                title: 'Conquer every exam',
                content:
                    'Get support for all your difficult subjects.'
            },
            
            {
                image: textbook,
                title: 'Become a Textbook Pro',
                content:
                    'Grasp IGCSE textbook concepts and practical uses with your online tutor.'
            },
            {
                image: examsSchool,
                title: 'Grow Plan',
                content:
                    'Get smarter with regular revisions and personalized ‘Grow Plan’.'
            }
        ]
    },
}
